import { Chip } from "@legal-500/legal500-design-system";
import type { DashboardStatus } from "@/api/dataProducts.service";
import { STATUS_LABELS } from "./dashboardKinds";
import styles from "./DataProducts.module.css";

const STATUS_CLASS_NAMES: Record<DashboardStatus, string> = {
  published: styles.statusPublished,
  draft: styles.statusDraft,
  archived: styles.statusArchived,
};

export function DashboardStatusChip({ status }: { status: DashboardStatus }) {
  return (
    <Chip size="small" variant="filled" className={STATUS_CLASS_NAMES[status]}>
      <span className={styles.statusLabel}>
        <span className={styles.statusDot} aria-hidden="true" />
        {STATUS_LABELS[status]}
      </span>
    </Chip>
  );
}
